import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { SecurityPsychAssessment } from "@/components/hr/SecurityPsychAssessment";
import { ProfessionalSkillsTest } from "@/components/hr/ProfessionalSkillsTest";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function CandidateTestPage() {
  const { candidateId } = useParams();
  const navigate = useNavigate();
  const [candidate, setCandidate] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [currentTest, setCurrentTest] = useState<'cognitive' | 'professional' | 'completed'>('cognitive');

  useEffect(() => {
    if (candidateId) {
      fetchCandidate();
    }
  }, [candidateId]);

  const fetchCandidate = async () => {
    try {
      const { data, error } = await supabase
        .from('candidates')
        .select('*')
        .eq('id', candidateId)
        .single();

      if (error) throw error;
      setCandidate(data);
      
      // Determine which test to show based on candidate status
      if (data.status === 'applied' || data.status === 'initial_review') {
        setCurrentTest('cognitive');
      } else if (data.status === 'first_test_completed') {
        setCurrentTest('professional');
      } else {
        setCurrentTest('completed');
      }
    } catch (error) {
      console.error('Error fetching candidate:', error);
      navigate('/hr');
    } finally {
      setLoading(false);
    }
  };

  const handleTestComplete = () => {
    // Check if we need to proceed to next test
    if (currentTest === 'cognitive') {
      setCurrentTest('professional');
      // Refresh candidate data to get updated status
      fetchCandidate();
    } else {
      // All tests completed, go back to HR dashboard
      navigate('/hr');
    }
  };

  const handleCancel = () => {
    navigate('/hr');
  };

  if (loading) {
    return (
      <Card className="max-w-2xl mx-auto">
        <CardContent className="p-6">
          <div className="text-center">Φόρτωση...</div>
        </CardContent>
      </Card>
    );
  }

  if (!candidate) {
    return (
      <Card className="max-w-2xl mx-auto">
        <CardContent className="p-6">
          <div className="text-center">Δεν βρέθηκε υποψήφιος</div>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="container mx-auto py-8">
      {currentTest === 'cognitive' ? (
        <SecurityPsychAssessment
          candidateId={candidate.id}
          candidateName={candidate.full_name}
          testType="cognitive"
          onComplete={handleTestComplete}
          onCancel={handleCancel}
        />
      ) : currentTest === 'professional' ? (
        <ProfessionalSkillsTest
          candidateId={candidate.id}
          candidateName={candidate.full_name}
          onComplete={handleTestComplete}
          onCancel={handleCancel}
        />
      ) : (
        <Card className="max-w-2xl mx-auto">
          <CardContent className="p-6">
            <div className="text-center">
              <h3 className="text-lg font-medium mb-2">Όλα τα τεστ ολοκληρώθηκαν</h3>
              <p className="text-muted-foreground mb-4">Ο υποψήφιος έχει ολοκληρώσει όλα τα απαραίτητα τεστ.</p>
              <Button onClick={() => navigate('/hr')}>
                Επιστροφή στο Dashboard
              </Button>
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
}